import { render, staticRenderFns } from "./SortingOptions.vue?vue&type=template&id=18cbc699&scoped=true&"
import script from "./SortingOptions.vue?vue&type=script&lang=js&"
export * from "./SortingOptions.vue?vue&type=script&lang=js&"
import style0 from "./SortingOptions.vue?vue&type=style&index=0&id=18cbc699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cbc699",
  null
  
)

export default component.exports